import { gql, useQuery } from '@apollo/client';
import { SortCriterion } from '../../contracts/types';
import { callSideEffects } from '../../util';
import { currentHotelSortCriterionVar } from './currentSortCriterion';
export const SORT_CRITERION_QUERY = gql `
    query CurrentHotelSortCriterion($tripStateId: ID!) {
        currentHotelSortCriterion @client
    }
`;
export function useHotelSortResults(sideEffects) {
    const setHotelSortResults = (sortCriterion) => {
        currentHotelSortCriterionVar(sortCriterion);
        callSideEffects(sideEffects, sortCriterion);
    };
    const { data: queryData } = useQuery(SORT_CRITERION_QUERY, {
        notifyOnNetworkStatusChange: true,
        ssr: false,
    });
    const hotelSortResults = (queryData === null || queryData === void 0 ? void 0 : queryData.currentHotelSortCriterion) || SortCriterion.RecommendedHighestFirst;
    return [hotelSortResults, setHotelSortResults];
}
